import { DataStatus } from '@/shared/lib';
import type { ProductDTO } from '../api/types';
import type { ApplicationType, Product } from '../model/types';

export const mapProduct = (dto: ProductDTO): Product => {
  return {
    id: dto.id,
    name: dto.name,
    applicationPlatforms: dto.applicationPlatforms as ApplicationType[],
    applications: [],
    applicationsDataStatus: DataStatus.idle,
    webfunnelLinks: [],
    webfunnelLinksDataStatus: DataStatus.idle,
    webhooks: [],
    webhooksDataStatus: DataStatus.idle,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};
